import type { FC } from 'react';

import LegalDocument from '@/features/legal/components/LegalDocument';
import { usePolicyPage } from '@/features/legal/hooks/usePolicyPage.hook';

const PolicyPage: FC = () => {
  const { content, lastUpdated } = usePolicyPage();

  return <LegalDocument content={content} lastUpdated={lastUpdated} />;
};

export default PolicyPage;
